<template>
    <button
        type="button"
        class="border text-white uppercase font-semibold tracking-wider leading-normal"
        :class="[
            size == 'small' ? 'text-2xs px-5 py-2' : 'text-xs px-6 py-3',
            disabled ? 'bg-gray-300 border-gray-300' : 'bg-red-600 border-red-600 hover:border-red-700 hover:bg-red-700 cursor-pointer',
        ]"
        @click="disabled ? null : $emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        size: { default: 'normal'},
        disabled: { default: false },
    },
}
</script>

